import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Standard shadcn `cn()` helper — merges class lists with Tailwind-aware dedupe so
 * conflicting utilities (e.g. `p-2` + `p-4`) resolve to the last one.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
